<template>
	<div>
		<common-header navbar-index=0></common-header>
		<home-banner></home-banner>
		<section id="services" class="services section-bg">
			<div class="container">
				<div class="section-title">
					<h2 data-aos="fade-in" class="aos-init aos-animate">{{leyuanInfo.title}}</h2>
					<p data-aos="fade-in" class="aos-init aos-animate">{{leyuanInfo.desc}}</p>
				</div>
				<div class="row">
					<div class="col-md-6 d-flex align-items-stretch aos-init leyuan-wrap" :data-aos="leyuan.aos" v-for="leyuan of leyuanInfo.list" :key="leyuan.id">
						<div class="card">
							<div class="card-img">
								<img :src="leyuan.img">
							</div>
							<div class="card-body">
								<h4 class="card-title"><a href="">{{leyuan.title}}</a></h4>
								<p class="card-text" v-for="p of leyuan.pList"><span class="fa fa-check-square-o" aria-hidden="true"></span> {{p}}</p>
								<div class="read-more">
									<a href="javascript:void(0)"><i class="icofont-arrow-right"></i> 了解更多</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section id="features" class="features section-bg">
			<div class="container">
				<div class="section-title">
					<h2 data-aos="fade-in" class="aos-init aos-animate">{{courseInfo.title}}</h2>
					<p data-aos="fade-in" class="aos-init">{{courseInfo.desc}}</p>
				</div>
				<div class="row content" v-for="course of courseInfo.list" :key="course.id" v-if="!course.type">
					<div class="col-md-5 aos-init" data-aos="fade-right">
						<img :src="course.img" class="img-fluid">
					</div>
					<div class="col-md-7 pt-4 aos-init" data-aos="fade-left">
						<h3>{{course.title}}</h3>
						<p class="font-italic">{{course.desc}}</p>
						<ul>
							<li v-for="p of course.pList"><i class="fa fa-check"></i> {{p}}</li>
						</ul>
					</div>
				</div>
				<div class="row content" v-else>
					<div class="col-md-5 order-1 order-md-2 aos-init" data-aos="fade-left">
						<img :src="course.img" class="img-fluid">
					</div>
					<div class="col-md-7 pt-5 order-2 order-md-1 aos-init" data-aos="fade-right">
						<h3>{{course.title}}</h3>
						<p class="font-italic">{{course.desc}}</p>
						<p style="font-size: 14px;line-height: 28px;" v-for="p of course.pList">{{p}}</p>
					</div>
				</div>
			</div>
		</section>
		<section id="portfolio" class="portfolio section-bg">
			<div class="container">
				<div class="section-title">
					<h2 data-aos="fade-in" class="aos-init aos-animate">{{anliInfo.title}}</h2>
					<p data-aos="fade-in" class="aos-init aos-animate">{{anliInfo.desc}}</p>
				</div>
				<div class="row">
					<div class="col-lg-12">
						<ul id="portfolio-flters">
							<li :class="{filter_active:0 == anliIndex}" @click="getAllAnli(0)">全部</li>
							<li :class="{filter_active:1 == anliIndex}" @click="getAnli(1)">编程学英语</li>
							<li :class="{filter_active:2 == anliIndex}" @click="getAnli(2)">编程解数学</li>
							<li :class="{filter_active:3 == anliIndex}" @click="getAnli(3)">游戏逻辑奥秘</li>
						</ul>
					</div>
				</div>
				<div class="row portfolio-container aos-init">
					<div class="col-lg-4 col-md-6 portfolio-item" v-for="anli of anliList" :key="anli.id">
						<a target="_blank" :href="anli.uri">
							<div class="portfolio-wrap">
								<img :src="anli.img" class="img-fluid">
								<div class="portfolio-info">
									<h4>{{anli.title}}</h4>
									<p>{{anli.desc}}</p>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</section>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import HomeBanner from '@/pages/home/components/HomeBanner'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Home',
		components: {
			CommonHeader,
			HomeBanner,
			CommonFooter
		},
		data() {
			return {
				leyuanInfo: [],
				courseInfo: [],
				anliInfo: [],
				anliList: [],
				anliIndex: 0
			}
		},
		methods: {
			getAllAnli(i) {
				this.anliIndex = i
				this.anliList = this.anliInfo.list
			},
			getAnli(i) {
				this.anliIndex = i
				let arr = []
				for(var o of this.anliInfo.list) {
					if(o.type == i) {
						arr.push(o)
					}
				}
				this.anliList = arr
			},
			getDataInfo() {
				axios.get('/data.v01.json')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.leyuanInfo = data.leyuanInfo
					this.courseInfo = data.courseInfo
					this.anliInfo = data.anliInfo
					this.anliList = data.anliInfo.list
				}
			}
		},
		mounted() {
			this.getDataInfo()
		}
	};
</script>

<style lang="scss" scoped>
	@import '@/assets/css/home/index.scss';
</style>